import { createAction, props } from '@ngrx/store';
import { ActionTypes } from './action-types';
import type { IntegrationScope, UpdateIntegrationPayload } from '../../../../models/integration-settings';

export const updateIntegrationAction = createAction(
  ActionTypes.UPDATE_INTEGRATION,
  props<{
    payload: {
      scope: IntegrationScope,
      integrationId: string,
      integration: UpdateIntegrationPayload,
    },
  }>()
);

export const updateIntegrationSuccessAction = createAction(
  ActionTypes.UPDATE_INTEGRATION_SUCCESS,
  props<{ data: boolean }>()
);

export const updateIntegrationFailureAction = createAction(
  ActionTypes.UPDATE_INTEGRATION_FAILURE,
  props<{ error: unknown }>()
);
